package input

import com.soywiz.korev.*

data class KeyState(
    var current: Boolean = false,
    var old: Boolean = false,
    var isPressed: Boolean = false
)

fun KeyState.changeStateByType(eventType: KeyEvent.Type) {
    when (eventType) {
        KeyEvent.Type.DOWN -> {
            if (!isPressed) {
                current = true
                old = false
                isPressed = true
            }
        }

        KeyEvent.Type.UP -> {
            current = false
            old = true
            isPressed = false
        }
        else -> {}
    }
}

fun KeyState.changeStateByPressed(pressed: Boolean) {
    if (pressed) {
        current = true
        old = false
        isPressed = true
    } else {
        current = false
        old = true
        isPressed = false
    }
}
